// @ts-nocheck
import { RELEASE_NOTES_LIST_ERROR, RELEASE_NOTES_LIST_LOADING, RELEASE_NOTES_LIST_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const release_notes_list = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: RELEASE_NOTES_LIST_LOADING,
                data: true
            })
            Authservices.release_notes_list(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: RELEASE_NOTES_LIST_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: RELEASE_NOTES_LIST_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}